export default {
  location: 'ContentfulBookingStepLocations',
  time: 'ContentfulBookingStepTime',
  personalData: 'ContentfulBookingStepFinalize',
  summary: 'ContentfulBookingStepSummary',
  reschedule: 'ContentfulBookingStepReschedule',
  waitlist: 'WaitlistData',
};
